import { jsx as e } from "react/jsx-runtime";
import { cva as a } from "class-variance-authority";
import * as o from "react";
import { cn as c } from "../../utils.js";
const n = ({
  ref: r,
  className: t
}) => /* @__PURE__ */ e(
  "svg",
  {
    ref: r,
    xmlns: "http://www.w3.org/2000/svg",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    className: t,
    stroke: "currentColor",
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    children: /* @__PURE__ */ e("path", { d: "M21 12a9 9 0 1 1-6.219-8.56" })
  }
), m = a("animate-spin duration-500", {
  variants: {
    size: {
      xs: "size-2",
      sm: "size-2.5",
      md: "size-4",
      lg: "size-6"
    },
    color: {
      primary: "text-primary-500",
      secondary: "text-secondary-500",
      warning: "text-warning-500",
      success: "text-success-500",
      critical: "text-critical-500",
      interactive: "text-interactive-500",
      white: "text-white",
      black: "text-black"
    }
  }
}), l = o.forwardRef(({ className: r, size: t, color: i = "primary" }, s) => /* @__PURE__ */ e(
  n,
  {
    ref: s,
    className: c(m({ color: i, size: t, className: r }))
  }
));
l.displayName = "CircularProgress";
export {
  l as CircularProgress
};
